import { ColumnsType } from 'antd/es/table';
import { Tag, Avatar } from 'antd';
import { CommunityPostSummaryResponseModel, UserType } from '@uniquegood/realworld-admin-interface';
import dayjs from 'dayjs';
import { UserOutlined } from '@ant-design/icons';
import { CopyableId } from './components/CopyableId';
import { UserIdLink } from '@src/components/UserIdLink';

const userTypeToString: Record<UserType, string> = {
  [UserType.Normal]: '일반',
  [UserType.Creator]: '크리에이터',
  [UserType.Admin]: '관리자',
};

const userTypeToColor: Record<UserType, string> = {
  [UserType.Normal]: 'default',
  [UserType.Creator]: 'blue',
  [UserType.Admin]: 'red',
};

export const columns: ColumnsType<CommunityPostSummaryResponseModel> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 100,
    render: (value) => <CopyableId value={value} />,
  },
  {
    title: '토픽',
    dataIndex: 'topicName',
    key: 'topic',
    width: 120,
    render: (value) => value || '-',
  },
  {
    title: '제목',
    dataIndex: 'title',
    key: 'title',
    width: 250,
    ellipsis: true,
  },
  {
    title: '작성자',
    key: 'writer',
    width: 150,
    render: (_, record) => (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Avatar
          size="small"
          src={record.writerProfileUrl}
          icon={!record.writerProfileUrl && <UserOutlined />}
        />
        {record.writerName ? (
          <UserIdLink userId={record.writerId!}>{record.writerName}</UserIdLink>
        ) : (
          <span style={{ color: '#999' }}>(탈퇴한 사용자)</span>
        )}
      </div>
    ),
  },
  {
    title: '유저 타입',
    dataIndex: 'userType',
    key: 'userType',
    width: 100,
    align: 'center',
    render: (value: UserType) => (
      <Tag color={userTypeToColor[value]}>{userTypeToString[value]}</Tag>
    ),
  },
  {
    title: '조회',
    dataIndex: 'viewCount',
    key: 'viewCount',
    width: 70,
    align: 'center',
  },
  {
    title: '좋아요',
    dataIndex: 'likeCount',
    key: 'likeCount',
    width: 70,
    align: 'center',
  },
  {
    title: '댓글',
    dataIndex: 'commentCount',
    key: 'commentCount',
    width: 70,
    align: 'center',
  },
  {
    title: '작성일',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 150,
    render: (value) => dayjs(value).format('YYYY-MM-DD HH:mm'),
  },
  {
    title: '삭제일',
    dataIndex: 'deletedAt',
    key: 'deletedAt',
    width: 150,
    render: (value) => (value ? dayjs(value).format('YYYY-MM-DD HH:mm') : '-'),
  },
];
